import { useContext } from 'react';
import { AuthContext } from '../../../Contexts/AuthContext';
import './styles.css';

const Footer = () => {
    const now = new Date().getFullYear();
    const { userEmail } = useContext(AuthContext);
    
    return(
        <div className='d-flex align-items-center justify-content-end footer-style'>
            <div>
                <span><b>Direitos autorais</b> FI-Group © {now}</span>
            </div>
            <div>
                <span className='ml'>{ userEmail }</span>
            </div>
        </div>
    );
}

export default Footer;